import React from 'react';
import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';
import { CaseCard } from './CaseCard';
import { CasesTable } from './CasesTable';
import { Case, TaskCounts } from '../../../types';

interface CasesListProps {
  cases: Case[];
  getTaskCounts: (caseId: string) => TaskCounts;
  onCaseClick: (caseId: string) => void;
}

export const CasesList: React.FC<CasesListProps> = ({
  cases,
  getTaskCounts,
  onCaseClick,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  if (cases.length === 0) {
    return (
      <Box 
        sx={{ 
          textAlign: 'center', 
          py: 4,
          color: 'text.secondary',
        }}
      >
        <Typography>No cases found matching your filters</Typography>
      </Box>
    );
  }

  return isMobile ? (
    <Box sx={{ mt: 2 }}>
      {cases.map((case_) => (
        <CaseCard
          key={case_.id}
          case_={case_}
          taskCounts={getTaskCounts(case_.id)}
          onClick={() => onCaseClick(case_.id)}
        />
      ))}
    </Box>
  ) : (
    <CasesTable
      cases={cases}
      getTaskCounts={getTaskCounts}
      onCaseClick={onCaseClick}
    />
  );
};